import React from 'react';
import styled from '@emotion/styled';
import { Link, graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { mobileBreakPoint } from 'src/utils/ResponsiveDesign';

const News = styled.div({
  marginLeft: '20px',
  marginRight: '20px',
});

const RightTitle = styled.div({
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottom: '1px solid #c6c7c8',
});

const ImgShow = styled(Img)({
  width: '100%',
});

const NewsItemLeft = styled.div({
  width: '50%',
});

const NewsItemRight = styled.div({
  width: '50%',
});

const SubTitle = styled.div({
  color: '#333',
});

const Text = styled(Link)({
  marginLeft: '10px',
  display: 'block',
  // margin: '10px',
});

const Desc = styled.div({
  color: '#575757',
  margin: '10px 0',
});

const RightTime = styled.div({
  color: '#888',
  // position: 'absolute',
  // bottom: '0',
  margin: '10px 0',
});

const NewsItem = styled.div({
  display: 'flex',
  marginTop: '20px',
  position: 'relative',
  [mobileBreakPoint]: {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'static',
    [NewsItemLeft]: {
      width: '100%',
    },
    [NewsItemRight]: {
      width: '100%',
    },
    [RightTime]: {
      position: 'static',
      marginTop: '10px',
    },
  },
});

const relatedNews = () => (
  <StaticQuery
    query={graphql`
      query RelatedNewsListQuery {
        news: allWordpressPost(
          sort: { fields: [date], order: DESC }
          filter: { tags: { elemMatch: { name: { in: ["moreNews"] } } } }
        ) {
          newsList: edges {
            news: node {
              id
              title
              excerpt
              slug
              content
              date(formatString: "YYYY.MM.DD")
              categories {
                name
              }
              tags {
                name
              }
              cover: featured_media {
                image: localFile {
                  childImageSharp {
                    fluid(maxHeight: 500, quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const hotNews = data.news.newsList;
      return (
        <News>
          <RightTitle>更多新闻</RightTitle>
          {hotNews.map(item => (
            <NewsItem key={item.news.id}>
              <NewsItemLeft>
                {item.news.cover && (
                  <ImgShow
                    fluid={item.news.cover.image.childImageSharp.fluid}
                    alt=""
                  />
                )}
              </NewsItemLeft>
              <NewsItemRight>
                <Text to={`/news/${item.news.slug}`}>
                  <SubTitle>
                    {item.news.title.split(',')[0] || item.news.title}
                  </SubTitle>
                  <Desc
                    dangerouslySetInnerHTML={{
                      __html: `${item.news.excerpt.substr(0, 40)}...`,
                    }}
                  />
                  <RightTime>{item.news.date}</RightTime>
                </Text>
              </NewsItemRight>
            </NewsItem>
          ))}
        </News>
      );
    }}
  />
);

export default relatedNews;
